import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingCart, ArrowRight } from "lucide-react";
import { useCompleteStep } from "../hooks/useCompleteStep";

const SalesStep: React.FC = () => {
  const navigate = useNavigate();
  const { complete, dashboardPath, isLastStep } = useCompleteStep("sales");

  const handleComplete = () => {
    complete();
    if (isLastStep) {
      navigate(dashboardPath);
    }
  };

  // Always the POS terminal, regardless of the current user's role
  const salesPath = "/cashier/items";

  return (
    <div className="max-w-md mx-auto text-center">
      <div className="rounded-xl border bg-white p-8 shadow-sm">
        <ShoppingCart className="h-12 w-12 text-primary mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">Make Your First Sale</h3>
        <p className="text-gray-500 text-sm mb-6">
          Everything is set up! Here's how to make a sale:
        </p>

        <ol className="text-left text-sm text-gray-600 space-y-3 mb-6">
          <li className="flex gap-2">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-xs font-bold">1</span>
            <span>Select your store and browse or search for products</span>
          </li>
          <li className="flex gap-2">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-xs font-bold">2</span>
            <span>Add items to the cart</span>
          </li>
          <li className="flex gap-2">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-xs font-bold">3</span>
            <span>Select a customer or add a new one (optional)</span>
          </li>
          <li className="flex gap-2">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-xs font-bold">4</span>
            <span>Click "Checkout" to complete the sale</span>
          </li>
        </ol>

        <button
          onClick={() => navigate(salesPath)}
          className="form-btn w-full flex items-center justify-center gap-2 mb-3"
        >
          <span>Go to Cashier — Make a Sale</span>
          <ArrowRight className="h-4 w-4" />
        </button>

        <button
          onClick={handleComplete}
          className="w-full rounded bg-green-600 px-4 py-2 text-white font-medium hover:bg-green-700 transition-colors"
        >
          {isLastStep ? "Complete Onboarding" : "Mark as Done"}
        </button>
      </div>
    </div>
  );
};

export default SalesStep;
